// Author YuJiaBei
// Date 2024-06-17 10:49:00

class SithMesPrdPpHeader {
    constructor({
                    id = null,
                    prpId = '',
                    ppdId = '',
                    ppHeaderType = '',
                    ppdActivityId = '',
                    salesOrder = '',
                    salesOrderItem = '',
                    parentId = '',
                    orderCode = '',
                    prdPpStatusCode = '',
                    orderType = '',
                    materialCode = '',
                    materialDescription = '',
                    basicStartTime = '',
                    basicFinishTime = '',
                    ppdForecastBeginTime = '',
                    ppdForecastEndTime = '',
                    forecastBeginTime = '',
                    forecastFinishTime = '',
                    bornlineBeginTime = '',
                    deadlineFinishTime = '',
                    actualStartTime = '',
                    actualEndTime = '',
                    priority = '',
                    isLocked = '',
                    validTime = '',
                    targetQuantity = '',
                    orderQuantity = '',
                    deleteQuantity = '',
                    createOn = '',
                    releaseOn = '',
                    enteredBy = '',
                    systemStatus = '',
                    deleteFlag = '',
                    profitCtr = '',
                    wbsCode = '',
                    sapChangedFlag = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.prpId = prpId;
        this.ppdId = ppdId;
        this.ppHeaderType = ppHeaderType;
        this.ppdActivityId = ppdActivityId;
        this.salesOrder = salesOrder;
        this.salesOrderItem = salesOrderItem;
        this.parentId = parentId;
        this.orderCode = orderCode;
        this.prdPpStatusCode = prdPpStatusCode;
        this.orderType = orderType;
        this.materialCode = materialCode;
        this.materialDescription = materialDescription;
        this.basicStartTime = basicStartTime;
        this.basicFinishTime = basicFinishTime;
        this.ppdForecastBeginTime = ppdForecastBeginTime;
        this.ppdForecastEndTime = ppdForecastEndTime;
        this.forecastBeginTime = forecastBeginTime;
        this.forecastFinishTime = forecastFinishTime;
        this.bornlineBeginTime = bornlineBeginTime;
        this.deadlineFinishTime = deadlineFinishTime;
        this.actualStartTime = actualStartTime;
        this.actualEndTime = actualEndTime;
        this.priority = priority;
        this.isLocked = isLocked;
        this.validTime = validTime;
        this.targetQuantity = targetQuantity;
        this.orderQuantity = orderQuantity;
        this.deleteQuantity = deleteQuantity;
        this.createOn = createOn;
        this.releaseOn = releaseOn;
        this.enteredBy = enteredBy;
        this.systemStatus = systemStatus;
        this.deleteFlag = deleteFlag;
        this.profitCtr = profitCtr;
        this.wbsCode = wbsCode;
        this.sapChangedFlag = sapChangedFlag;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesPrdPpHeader();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prpId',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.prpId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prpCode',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.prpCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prpName',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.prpName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ppdId',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ppHeaderType',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppHeaderType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '未替换'},
                    {value: '2', text: '已替换'},
                    {value: '3', text: '虚拟'}
                ]
            }
        },
        {
            key: 'ppdActivityId',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdActivityId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.projectName',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrder',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.salesOrder',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrderItem',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.salesOrderItem',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'parentId',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.parentId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'parentOrderCode',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.parentOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdPpStatusName',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.prdPpStatusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderType',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.orderType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'common_link',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.materialDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'priority',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.priority',
            sortable: true,
            form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'basicStartTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.basicStartTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'basicFinishTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.basicFinishTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ppdForecastBeginTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdForecastBeginTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ppdForecastEndTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdForecastEndTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastBeginTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.forecastBeginTime',
            sortable: true,
            form: {
                type: 'input',
                //已排产未下发的工单，计划开始时间提前10天变黄，超过今天的变红
                customClass: (row) => {
                    if (row.prdPpStatusName === '已排产' && row.forecastBeginTime) {
                        let currTime = new Date()
                        currTime.setHours(0, 0, 0, 0)
                        let warnTime = new Date().setDate(currTime.getDate() + 10);
                        //把字符串格式转化为日期类
                        let forecastBeginTime = new Date(Date.parse(row.forecastBeginTime))
                        if (forecastBeginTime < currTime)
                            return "bg-danger text-white"
                        else if (forecastBeginTime < warnTime)
                            return "bg-warning text-dark"
                    }
                    return ""
                }
            }
        },
        {
            key: 'forecastFinishTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.forecastFinishTime',
            sortable: true,
            form: {
                type: 'input',
                //计划完成时间超过了deadline变红
                customClass: (row) => {
                    console.log("进入了判断")
                    if (row.deadlineFinishTime && row.forecastFinishTime && row.prdPpStatusName !== '已完工') {
                        //把字符串格式转化为日期类
                        let forecastFinishTime = new Date(Date.parse(row.forecastFinishTime))
                        let deadlineFinishTime = new Date(Date.parse(row.deadlineFinishTime))
                        if (forecastFinishTime >= deadlineFinishTime)
                            return "bg-danger text-white"
                    }
                    return ""
                }
            }
        },
        {
            key: 'bornlineBeginTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.bornlineBeginTime',
            sortable: true,
            form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deadlineFinishTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.deadlineFinishTime',
            sortable: true,
            form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualStartTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.actualStartTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualEndTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.actualEndTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baselineBeginTime1',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineBeginTime1',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baselineFinishTime1',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineFinishTime1',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baselineBeginTime2',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineBeginTime2',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baselineFinishTime2',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineFinishTime2',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bornlineDeviation',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.bornlineDeviation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deadlineDeviation',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.deadlineDeviation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baselineBeginDeviation',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineBeginDeviation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baselineFinishDeviation',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineFinishDeviation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastBeginDeviation',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.forecastBeginDeviation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'forecastEndDeviation',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.forecastEndDeviation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'omBeginDeviation',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.omBeginDeviation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'omEndDeviation',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.omEndDeviation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualFinishTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.actualFinishTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isLocked',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.isLocked',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'validTime',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.validTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'targetQuantity',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.targetQuantity',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderQuantity',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.orderQuantity',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deleteQuantity',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.deleteQuantity',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createOn',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.createOn',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'releaseOn',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.releaseOn',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'enteredBy',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.enteredBy',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'systemStatus',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.systemStatus',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deleteFlag',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.deleteFlag',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'profitCtr',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.profitCtr',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsCode',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.wbsCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sapChangedFlag',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.sapChangedFlag',
            sortable: true,
            isDetail: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '未变化'},
                    {value: '1', text: '从未释放到已释放'},
                    {value: '2', text: '关键信息变更'},
                    {value: '3', text: '删除'}
                ]
            }
        },
        {
            key: 'ppdBaselineBeginTime2',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdBaselineBeginTime2',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ppdBaselineFinishTime2',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdBaselineFinishTime2',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isUpdated',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.isUpdated',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.prd.sithMesPrdPpHeader.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const virtualVoConfigs = [
    {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.id',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prpId',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.prpId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prpCode',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.prpCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prpName',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.prpName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdId',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderType',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppHeaderType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未替换'},
                {value: '2', text: '已替换'},
                {value: '3', text: '虚拟'}
            ]
        }
    },
    {
        key: 'ppdActivityId',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdActivityId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.projectName',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrder',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.salesOrder',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrderItem',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.salesOrderItem',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentId',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.parentId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentOrderCode',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.parentOrderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.orderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpStatusName',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.prdPpStatusName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderType',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.orderType',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.materialCode',
        sortable: true,
        form: {
            type: 'input',
            linkTo: 'common_link',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.materialDescription',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'priority',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.priority',
        sortable: true,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'basicStartTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.basicStartTime',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'basicFinishTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.basicFinishTime',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastBeginTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdForecastBeginTime',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastEndTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdForecastEndTime',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.forecastBeginTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.forecastFinishTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bornlineBeginTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.bornlineBeginTime',
        sortable: true,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deadlineFinishTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.deadlineFinishTime',
        sortable: true,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualStartTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.actualStartTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualEndTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.actualEndTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginTime1',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineBeginTime1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishTime1',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineFinishTime1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginTime2',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineBeginTime2',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishTime2',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineFinishTime2',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bornlineDeviation',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.bornlineDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deadlineDeviation',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.deadlineDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginDeviation',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineBeginDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishDeviation',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.baselineFinishDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginDeviation',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.forecastBeginDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastEndDeviation',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.forecastEndDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omBeginDeviation',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.omBeginDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omEndDeviation',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.omEndDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualFinishTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.actualFinishTime',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isLocked',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.isLocked',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'validTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.validTime',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'targetQuantity',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.targetQuantity',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderQuantity',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.orderQuantity',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deleteQuantity',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.deleteQuantity',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createOn',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.createOn',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'releaseOn',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.releaseOn',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'enteredBy',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.enteredBy',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'systemStatus',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.systemStatus',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deleteFlag',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.deleteFlag',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitCtr',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.profitCtr',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsCode',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.wbsCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapChangedFlag',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.sapChangedFlag',
        sortable: true,
        isDetail: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '未变化'},
                {value: '1', text: '从未释放到已释放'},
                {value: '2', text: '关键信息变更'},
                {value: '3', text: '删除'}
            ]
        }
    },
    {
        key: 'ppdBaselineBeginTime2',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdBaselineBeginTime2',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdBaselineFinishTime2',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.ppdBaselineFinishTime2',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpHeader.grid.remark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

const filter = {
    idFilter: '',
    idInFilter: [],
    prpIdFilter: '',
    prpCodeFilter: '',
    prpNameFilter: '',
    ppdIdFilter: '',
    ppHeaderTypeInFilter: [],
    ppdActivityIdFilter: '',
    salesOrderFilter: '',
    salesOrderItemFilter: '',
    projectCodeFilter: '',
    projectNameFilter: '',
    parentOrderCodeFilter: '',
    parentIdFilter: '',
    orderCodeFilter: '',
    orderCodeInFilter: [],
    prdPpStatusCodeFilter: [],
    orderTypeFilter: '',
    materialCodeFilter: '',
    materialDescriptionFilter: '',
    isLockedFilter: '',
    projectMachine2Filter: '',
    sapChangedFlagFilter: '',
    forecastBeginTimeRteFilter: '',
    forecastBeginTimeLteFilter: '',
    forecastFinishTimeRteFilter: '',
    forecastFinishTimeLteFilter: '',
    ppdForecastBeginTimeRteFilter: '',
    ppdForecastBeginTimeLteFilter: '',
    ppdForecastEndTimeRteFilter: '',
    ppdForecastEndTimeLteFilter: '',
    bornlineBeginTimeRteFilter: '',
    bornlineBeginTimeLteFilter: '',
    deadlineFinishTimeRteFilter: '',
    deadlineFinishTimeLteFilter: '',
    priorityFilter: '',
    actualEndTimeRteFilter: '',
    actualEndTimeLteFilter: '',
    releaseOnRteFilter: '',
    releaseOnLteFilter: '',
    baselineBeginTime1RteFilter: '',
    baselineBeginTime1LteFilter: '',
    baselineFinishTime1RteFilter: '',
    baselineFinishTime1LteFilter: '',
    baselineBeginTime2RteFilter: '',
    baselineBeginTime2LteFilter: '',
    baselineFinishTime2RteFilter: '',
    baselineFinishTime2LteFilter: '',
    bornlineDeviationRteFilter: '',
    bornlineDeviationLteFilter: '',
    deadlineDeviationRteFilter: '',
    deadlineDeviationLteFilter: '',
    baselineBeginDeviationRteFilter: '',
    baselineBeginDeviationLteFilter: '',
    baselineFinishDeviationRteFilter: '',
    baselineFinishDeviationLteFilter: '',
    forecastBeginDeviationRteFilter: '',
    forecastBeginDeviationLteFilter: '',
    forecastEndDeviationRteFilter: '',
    forecastEndDeviationLteFilter: '',
    omBeginDeviationRteFilter: '',
    omBeginDeviationLteFilter: '',
    omEndDeviationRteFilter: '',
    omEndDeviationLteFilter: '',
    enteredByFilter: '',
    wbsCodeFilter: '',
    wbsCodeStartsWithFilter: '',
    isAttachmentUploadedFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'prpCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.prpCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prpNameFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.prpName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderTypeInFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppHeaderTypeIn',
        disabled: false,
        form: {
            type: 'selectMultiple',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未替换'},
                {value: '2', text: '已替换'},
                {value: '3', text: '虚拟'}
            ]
        }
    },
    {
        key: 'ppdActivityIdFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdActivityId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.parentOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpStatusCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.prdPpStatusCode',
        disabled: false,
        form: {
            type: 'entitySelectMultiple',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpStatus'
            , correspondingField: 'id'
        }
    },
    {
        key: 'orderTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.orderType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.materialDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isLockedFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.isLocked',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine2Filter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.projectMachine2',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastFinishTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastFinishTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastEndTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastEndTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'priorityFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.priority',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginTime1RteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineBeginTime1Rte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginTime1LteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineBeginTime1Lte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishTime1RteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineFinishTime1Rte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishTime1LteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineFinishTime1Lte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginTime2RteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineBeginTime2Rte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginTime2LteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineBeginTime2Lte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishTime2RteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineFinishTime2Rte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishTime2LteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineFinishTime2Lte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bornlineDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.bornlineDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bornlineDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.bornlineDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deadlineDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.deadlineDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deadlineDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.deadlineDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineBeginDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineBeginDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineFinishDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineFinishDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastEndDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastEndDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastEndDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastEndDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omBeginDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.omBeginDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omBeginDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.omBeginDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omEndDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.omEndDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omEndDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.omEndDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'enteredByFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.enteredBy',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.wbsCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAttachmentUploadedFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.isAttachmentUploaded',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];
const virtualFilterConfigs = [
    {
        key: 'prpCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.prpCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppHeaderTypeInFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppHeaderTypeIn',
        disabled: false,
        form: {
            type: 'selectMultiple',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未替换'},
                {value: '2', text: '已替换'},
                {value: '3', text: '虚拟'}
            ]
        }
    },
    {
        key: 'ppdActivityIdFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdActivityId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.parentOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpStatusCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.prdPpStatusCode',
        disabled: false,
        form: {
            type: 'entitySelectMultiple',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpStatus'
            , correspondingField: 'id'
        }
    },
    {
        key: 'orderTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.orderType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.materialDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isLockedFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.isLocked',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine2Filter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.projectMachine2',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastFinishTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastFinishTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastEndTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastEndTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'priorityFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.priority',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bornlineDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.bornlineDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bornlineDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.bornlineDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deadlineDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.deadlineDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deadlineDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.deadlineDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineBeginDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineBeginDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineBeginDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineFinishDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baselineFinishDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.baselineFinishDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastEndDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastEndDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastEndDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastEndDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omBeginDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.omBeginDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omBeginDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.omBeginDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omEndDeviationRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.omEndDeviationRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'omEndDeviationLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.omEndDeviationLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'enteredByFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.enteredBy',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.wbsCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAttachmentUploadedFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.isAttachmentUploaded',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];
const dispatchFilterConfigs = [
    {
        key: 'forecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastFinishTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastFinishTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastEndTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastEndTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    }
];
const executeFilterConfigs = [
    {
        key: 'forecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastFinishTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.forecastFinishTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastEndTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ppdForecastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeader.filter.ppdForecastEndTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'ppHeaderType',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.ppHeaderType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '未替换'},
                {value: '2', text: '已替换'},
                {value: '3', text: '虚拟'}
            ]
        }
    },
    {
        key: 'ppdActivityId',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.ppdActivityId',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrder',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.salesOrder',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrderItem',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.salesOrderItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentId',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.orderCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'prdPpStatusCode',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.prdPpStatusCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'sithMesPrdPpStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'orderType',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.orderType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.materialDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'basicStartTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.basicStartTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'basicFinishTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.basicFinishTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastBeginTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.forecastBeginTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'forecastFinishTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.forecastFinishTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'bornlineBeginTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.bornlineBeginTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deadlineFinishTime',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.deadlineFinishTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'priority',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.priority',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isLocked',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.isLocked',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'targetQuantity',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.targetQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'orderQuantity',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.orderQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createOn',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.createOn',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'releaseOn',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.releaseOn',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'enteredBy',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.enteredBy',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'profitCtr',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.profitCtr',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsCode',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.wbsCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpHeader.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesPrdPpHeader, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs, virtualFilterConfigs, dispatchFilterConfigs, executeFilterConfigs

    , virtualVoConfigs
}
